import { render, staticRenderFns } from "./client-journal-actions.vue?vue&type=template&id=4ace8c68"
import script from "./client-journal-actions.vue?vue&type=script&lang=js"
export * from "./client-journal-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports